<script lang="ts" setup>
import { ref, watch } from 'vue';
import chevronUp from '@/assets/images/icons8-chevron-up.svg?component';
import chevronDown from '@/assets/images/icons8-chevron-down.svg?component';

interface IProps {
  enableCollapse?: boolean;
  startCollapsed?: boolean;
  collapse?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  enableCollapse: true,
  startCollapsed: false,
  collapse: false,
});

const showContent = ref(!props.startCollapsed);

const toggle = () => {
  if (props.enableCollapse === true) {
    showContent.value = !showContent.value;
  }
};

const collapsePropWatcher = (newValue: boolean) => {
  showContent.value = !newValue;
};

watch(() => props.collapse, collapsePropWatcher);
</script>

<template>
  <fieldset class="px-1 pt-0.5 pb-2 mb-1 bg-black/[0.02] custom-box-shadow rounded-[2px] mx-[4px]">
    <legend class="text-xs font-bold flex flex-row items-center break-word" :class="{ 'cursor-pointer': props.enableCollapse === true }" @click="toggle">
      <slot name="legend" />

      <component :is="showContent ? chevronUp : chevronDown" v-if="props.enableCollapse === true || props.enableCollapse === undefined" class="ml-[5px] text-black w-[8px] h-[8px]" />
    </legend>

    <div class="px-1">
      <slot v-if="showContent === true" />
    </div>
  </fieldset>
</template>

<style lang="css" scoped>
.custom-box-shadow {
  box-shadow: rgb(0 0 0 / 15%) 1px 1px 2px 0px, rgb(0 0 0 / 25%) 0px 0px 2px 0px;
}
</style>
